import { styled } from "styled-components";

export const MyInfoEditeInput = styled.input`
  font-size: 18px;

  height: 32px;
  outline: none;
  border: none;
  border-bottom: 2px solid #383838;
  padding: 12px;
  margin-bottom: 8px;
`;
